import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';

const SelectedChips = ({ className, disabled, selectedItems, visibleSelectedCount = 2, removeSelectedItem, getSelectedItemLabel = (item)=>item.label })=>{
    const handleRemoveItem = useCallback((item)=>(e)=>{
            e.stopPropagation();
            if (!disabled) {
                removeSelectedItem(item);
            }
        }, [
        removeSelectedItem,
        disabled
    ]);
    if (selectedItems.length === 0) {
        return null;
    }
    if (disabled) {
        return jsx("div", {
            className: "selected-chips-disabled",
            "data-testid": "selected-chips",
            children: selectedItems.map((item)=>item.label).join(', ')
        });
    }
    return jsxs("div", {
        className: classNames('selected-chips-container', className),
        "data-testid": "selected-chips",
        children: [
            selectedItems.slice(0, visibleSelectedCount).map((item, index)=>jsxs("span", {
                    className: "chip",
                    children: [
                        jsx("span", {
                            className: "label",
                            children: getSelectedItemLabel(item)
                        }),
                        jsx(Icon, {
                            className: "icon",
                            name: "XSolid",
                            onClick: handleRemoveItem(item),
                            size: 16
                        })
                    ]
                }, index)),
            selectedItems.length > visibleSelectedCount && jsx("span", {
                className: "counter-chip",
                children: jsxs("span", {
                    className: "label",
                    children: [
                        "+",
                        selectedItems.length - visibleSelectedCount
                    ]
                })
            })
        ]
    });
};

export { SelectedChips };
//# sourceMappingURL=SelectedChips.es.js.map
